import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.css'],
    standalone: false
})
export class UserInfoComponent {
  @Input() userInfoForm!: FormGroup;

  @Input() set value(value: any) {
    if (value && this.userInfoForm) {
      this.userInfoForm.patchValue(value);
    }
  }

  @Output() goNext = new EventEmitter<any>();

  handleNextClick() {
      if (!this.isUserInfoValid) return;

    this.goNext.emit(this.userInfoForm.value);
  }
  
  get isUserInfoValid(): boolean {
    const info = this.userInfoForm.get.bind(this.userInfoForm);
    return (
      info('firstName')?.valid &&
      info('lastName')?.valid &&
      info('preferredBusinessFax')?.valid &&
      info('preferredBusinessPhone')?.valid &&
      (info('phoneNumberExtension')?.valid ?? true)
    ) as boolean;
  }

}
